export default "__VITE_ASSET__Cxe0V09y__"